// imports
import { FC, useContext } from 'react';
import DoneIcon from '@mui/icons-material/Check';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardActions, CardContent, Typography } from '@mui/material';

// interfaces, constants, helper
import { SECONDARY_FONT } from 'constants/fonts';
import { ALREADY_SUBSCRIBED_TEXT, PlanTabsEnum, SEAT_TEXT, STRIPE_CHECKOUT_ROUTE } from 'constants/index';
import { CheckoutContext } from 'contexts/CheckoutContext';
import { PlanCardProps } from 'interfaces';
import { ActionType } from 'reducer/checkoutReducer';

export const PlanCard: FC<PlanCardProps> = ({ priceId, product, interval, amount, disabled, isModal }) => {
  const navigate = useNavigate();

  const { dispatch } = useContext(CheckoutContext);
  const { images = [], marketingFeatures = [], description = '' } = product || {};
  const latestImage = images?.[images.length - 1];
  const intervalText = interval?.toLowerCase() || '';

  const handleChoosePlan = () => {
    if (isModal && priceId) {
      dispatch({ type: ActionType.SET_PRICE_ID, priceId });
      dispatch({ type: ActionType.SET_TAB, tab: PlanTabsEnum.CHECKOUT });
    } else if (priceId) {
      navigate(`${STRIPE_CHECKOUT_ROUTE}/${priceId}`);
    }
  };

  return (
    <Card sx={{ padding: 4, opacity: disabled ? 0.5 : 1 }}>
      <CardContent>
        <Box pb={2} textAlign="center">
          {interval && (
            <Typography variant="overline" color="text.secondary" gutterBottom>
              {`${interval.toUpperCase()}LY`}
            </Typography>
          )}
          <Box display="flex" justifyContent="center" gap={1} mt={2}>
            <Typography variant="subtitle1" component="p">
              $
            </Typography>
            <Typography variant="h3" fontFamily={SECONDARY_FONT}>
              {amount}
            </Typography>
            <Typography variant="subtitle1" component="p" mt={1}>
              {`/${SEAT_TEXT}`}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" flexDirection="column" alignItems="center">
          {description && (
            <Typography variant="subtitle2" color="primary" component="p" mb={3}>
              {description}
            </Typography>
          )}
          {latestImage && (
            <Box>
              <img width={60} height={60} src={latestImage} alt={`${intervalText} plan`} />
            </Box>
          )}
        </Box>
        <Box mt={4}>
          {marketingFeatures?.map(
            (feature) =>
              feature.name && (
                <Box key={feature.name} display="flex" alignItems="center" gap={2} mb={1}>
                  <DoneIcon sx={{ fontSize: 16 }} />
                  <Typography variant="caption" color="text.white">
                    {feature.name}
                  </Typography>
                </Box>
              ),
          )}
        </Box>
      </CardContent>
      <CardActions>
        {interval && (
          <Button
            onClick={handleChoosePlan}
            size="large"
            variant="contained"
            fullWidth
            disabled={!priceId || !amount || disabled}>
            {disabled ? ALREADY_SUBSCRIBED_TEXT : `Choose ${intervalText}ly`}
          </Button>
        )}
      </CardActions>
    </Card>
  );
};
